import SenateCommittee from './SenateCommittee';

export default class JointCommittee extends SenateCommittee {}
